import Icon from "@ant-design/icons";
import { Card, Col, Flex, Row, Skeleton, Typography, Space, Divider } from "antd";
import users from "../../assets/image/dealers";
import products from "../../assets/image/products";
import adverts from "../../assets/image/adverts";
import { useQuery } from "@tanstack/react-query";
import { getDashboardStatistics } from "../../services/statisticService";
import Bar from "../../components/Charts/Bar";
import { getAdvertAndDealerCountForYearly } from "../../services/reportService";

export default function Home() {
  const { data, isPending, isFetching } = useQuery({
    queryKey: ["dashboard-stats"],
    queryFn: getDashboardStatistics,
  });

  const { data: statistic } = useQuery({
    queryKey: ["advert-dealer-count-yearly"],
    queryFn: () => getAdvertAndDealerCountForYearly(new Date().getFullYear()),
  });

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>

        <Col xs={24} md={8}>
          <Card
            title={
              <Space size="large">
                <Icon component={products} style={{ fontSize: 20 }} />
                <Typography.Text strong style={{ fontSize: 16 }}>Ürün</Typography.Text>
              </Space>
            }
            loading={isPending || isFetching}
            style={{
              height: "100%",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: 8
            }}
            headStyle={{ padding: "16px 16px 12px" }}
            bodyStyle={{ padding: "16px" }}
          >
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Toplam Ürün</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600 }}>
                  {data?.entity?.totalProductCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Aktif Ürün</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#52c41a" }}>
                  {data?.entity?.activeProductCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Pasif Ürün</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#ff4d4f" }}>
                  {data?.entity?.passiveProductCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card
            title={
              <Space size="large">
                <Icon component={users} style={{ fontSize: 20 }} />
                <Typography.Text strong style={{ fontSize: 16 }}>Bayi</Typography.Text>
              </Space>
            }
            loading={isPending || isFetching}
            style={{
              height: "100%",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: 8
            }}
            headStyle={{ padding: "16px 16px 12px" }}
            bodyStyle={{ padding: "16px" }}
          >
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Toplam Bayi</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600 }}>
                  {data?.entity?.totalDealerCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Aktif Bayi</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#52c41a" }}>
                  {data?.entity?.activeDealerCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Pasif Bayi</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#ff4d4f" }}>
                  {data?.entity?.passiveDealerCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Onaylı Bayi</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#1890ff" }}>
                  {data?.entity?.approvedDealerCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Onaysız Bayi</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#faad14" }}>
                  {data?.entity?.unapprovedDealerCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card
            title={
              <Space size="large">
                <Icon component={adverts} style={{ fontSize: 20 }} />
                <Typography.Text strong style={{ fontSize: 16 }}>İlan</Typography.Text>
              </Space>
            }
            loading={isPending || isFetching}
            style={{
              height: "100%",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: 8
            }}
            headStyle={{ padding: "16px 16px 12px" }}
            bodyStyle={{ padding: "16px" }}
          >
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Toplam İlan</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600 }}>
                  {data?.entity?.totalAdvertCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Aktif İlan</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#52c41a" }}>
                  {data?.entity?.activeAdvertCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
              <Divider style={{ margin: "4px 0" }} />
              <Flex justify="space-between" align="center" style={{ padding: "4px 0" }}>
                <Typography.Text style={{ fontSize: 14, color: "#595959" }}>Pasif İlan</Typography.Text>
                <Typography.Text strong style={{ fontSize: 18, fontWeight: 600, color: "#ff4d4f" }}>
                  {data?.entity?.passiveAdvertCount?.toString() || "0"}
                </Typography.Text>
              </Flex>
            </Space>
          </Card>
        </Col>
      </Row>

      <Col span={24}>
        <Bar
          dataType="ordinal"
          title="Aylık Müşteri Kazanımı"
          data={statistic?.entity.monthlyStats}
        />
        <Bar
          dataType="ordinal"
          title="Aylık İlan Ekleme Oranı"
          data={statistic?.entity.monthlyStats}
        />
      </Col>
    </>
  );
}
